<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="onSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">รหัสร้านค้า (ตัวแทนจำหน่ายย่อย):</label>
                <input
                  id="essaShopSubAgentCode"
                  name="essaShopSubAgentCode"
                  v-model="essaShopSubAgentCode"
                  type="text"
                  maxlength="50"
                  class="form-control"
                  placeholder="ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย):</label>
                <input
                  id="essaShopSubAgentName"
                  name="essaShopSubAgentName"
                  v-model="essaShopSubAgentName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required"
                  >ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย):</label
                >
                <input
                  id="essaShopSubAgentName2"
                  name="essaShopSubAgentName2"
                  v-model="essaShopSubAgentName2"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ประเภทร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaShopType'"
                  :name="'essaShopType'"
                  :select2-options="essaShopTypeOptions"
                  v-model="essaShopType"
                  ref="essaShopTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ประเภทการล้างเครื่อง:  </label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaShopPMType'"
                  :name="'essaShopPMType'"
                  :select2-options="essaShopPMTypeOptions"
                  v-model="essaShopPMType"
                  ref="essaShopPMTypeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">สถานะประเภทร้านค้า:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'eShShopGroup'"
                  :name="'eShShopGroup'"
                  :select2-options="eShShopGroupOptions"
                  v-model="eShShopGroup"
                  ref="eShShopGroupSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ที่อยู่:</label>
                <input
                  id="essaAddress"
                  name="essaAddress"
                  v-model="essaAddress"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ที่อยู่"
                />
              </div>
            </div>
            
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>จังหวัด:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaProvinceId'"
                  :name="'essaProvinceId'"
                  :select2-options="essaProvinceIdOptions"
                  v-model="essaProvinceId"
                  ref="essaProvinceIdSelect2"
                  @selectChange="onProvinceIdChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>อำเภอ:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaAmphurId'"
                  :name="'essaAmphurId'"
                  :select2-options="essaAmphurIdOptions"
                  v-model="essaAmphurId"
                  ref="essaAmphurIdSelect2"
                  @selectChange="onAmphurIdChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>ตำบล:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaTumbolId'"
                  :name="'essaTumbolId'"
                  :select2-options="essaTumbolIdOptions"
                  v-model="essaTumbolId"
                  ref="essaTumbolIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้ติดต่อ:</label>
                <input
                  id="essaContactFullName"
                  name="essaContactFullName"
                  v-model="essaContactFullName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อ-สกุลผู้ติดต่อ"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">อีเมล:</label>
                <input
                  id="essaEmail"
                  name="essaEmail"
                  v-model="essaEmail"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="อีเมล"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label>เบอร์โทร:</label>
                <input
                  id="essaTel"
                  name="essaTel"
                  v-model="essaTel"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="เบอร์โทร"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย:</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaShopCode'"
                  :name="'essaShopCode'"
                  :select2-options="essaShopCodeOptions"
                  v-model="essaShopCode"
                  ref="essaShopCodeSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">ชื่อเจ้าหน้าที่ดูแล (ร้านค้า):</label>
                <input
                  id="essaContactShopName"
                  name="essaContactShopName"
                  v-model="essaContactShopName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="ชื่อเจ้าหน้าที่ดูแล (ร้านค้า)"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า):</label>
                <input
                  id="essaContactShopLName"
                  name="essaContactShopLName"
                  v-model="essaContactShopLName"
                  type="text"
                  maxlength="256"
                  class="form-control"
                  placeholder="นามสกุลเจ้าหน้าที่ดูแล (ร้านค้า)"
                />
              </div>
            </div>
            <div class="col-xl-6" v-if="$root.canShow('super_admin')">
              <div class="form-group">
                <label class="label">เจ้าหน้าที่ดูแล (Boonrawd)</label>
                <select2
                  :class="'form-control m-select2'"
                  :style="'width: 100%;'"
                  :id="'essaEmpId'"
                  :name="'essaEmpId'"
                  :select2-options="essaEmpIdOptions"
                  v-model="essaEmpId"
                  ref="essaEmpIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!-- Begin: CR-PM-2026 Req 2 — ตั้งค่าระยะ Check-In/Check-Out -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label class="label-required">ตั้งค่าระยะ Check-In/Check-Out:</label>
                <div>
                  <label class="kt-radio kt-radio--bold kt-radio--brand" style="margin-right: 30px;">
                    <input type="radio" v-model="useSettingCheckinRange" :value="true" /> กำหนดตามตั้งค่าพื้นฐาน
                    <span></span>
                  </label>
                  <label class="kt-radio kt-radio--bold kt-radio--brand">
                    <input type="radio" v-model="useSettingCheckinRange" :value="false" /> กำหนดเอง
                    <span></span>
                  </label>
                  <button v-if="!useSettingCheckinRange" type="button" class="btn btn-sm btn-clean btn-icon"
                    @click="resetCheckinRange" title="ใช้ค่า default">
                    <i class="la la-times"></i>
                  </button>
                </div>
                <!-- Issue 2: defensive UI -->
                <div v-if="useSettingCheckinRange && apiLoadedCheckInRange === null" class="alert alert-warning mt-2" style="max-width: 500px;">
                  <i class="la la-exclamation-triangle"></i> ให้ไป apply ค่าที่หน้า ตั้งค่าพื้นฐาน
                </div>
                <div v-if="!useSettingCheckinRange" class="mt-2" style="max-width: 300px;">
                  <label class="label-required">ระยะ (เมตร):</label>
                  <input type="number" min="1" max="10000" v-model.number="customCheckInRange"
                    class="form-control" placeholder="ระบุระยะ (เมตร)" name="customCheckInRange"
                    @input="checkCustomCheckInRangeMax" @change="checkCustomCheckInRangeMax" />
                  <span v-if="customCheckInRangeMaxError" class="text-danger small">{{ customCheckInRangeMaxError }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- End: CR-PM-2026 Req 2 -->

          <!-- Begin:Map element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>ตำแหน่งที่ตั้ง:</label>
                <div v-if="essaLat === null">
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block col-xl-2"
                    @click="getMap"
                  >
                    ระบุข้อมูลตำแหน่งที่ตั้ง
                  </button>
                </div>
                <div v-else>
                  <GmapMap
                    :center="{ lat: essaLat, lng: essaLng }"
                    :zoom="15"
                    :clickable="true"
                    @click="updateCoordinates"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in essaMarkers"
                      :position="m.position"
                      :draggable="true"
                      @drag="updateCoordinates"
                      :clickable="true"
                      @click="updateCoordinates"
                    ></gmap-marker>
                  </GmapMap>
                  <br />
                  <div>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="openMap()"
                    >
                      <i class="far fa-map"></i> Open GoogleMaps
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Map element -->

          <!-- Begin:Picture element (GCS Upload) -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label
                  >รูปภาพ:<span
                    class="text-sm text-danger"
                    style="font-size:small"
                  >
                    (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน 10Mb.)</span
                  ></label
                >
                <button
                  type="button"
                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                  @click="uploadFile"
                >
                  <i class="flaticon-upload-1"></i>รูป
                </button>
                <div class="row" id="container-img">
                  <div
                    v-for="(image, index) in FileUpload"
                    :key="index"
                    class="col-md-4 m--margin-top-20 img-wrap"
                  >
                    <img
                      v-if="image.isLoaded !== false"
                      :src="image.urlImg"
                      class="img-plant img-thumbnail card-img-top"
                      @error="handleImageError(image)"
                      @load="handleImageLoad(image)"
                    />
                    <div v-else class="img-placeholder">ไม่สามารถโหลดรูปภาพได้</div>
                    <a
                      href="javascript:;"
                      style="position:absolute;top:10px;right:20px;"
                      class="btn m-btn--pill btn-danger m-btn close"
                      @click="removeImage(image.pictureId)"
                    >
                      <span class="m--font-inverse-danger la la-trash"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:Picture element -->

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="essaInActiveStatus"
                      name="essaInActiveStatus"
                      v-model="essaInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- End:InActiveStatus element -->

          <div v-if="this.$root.canShow([''])" class="col-xl-12">
            <div class="form-group">
              <label>[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)</label>
              <div class="form-check">
                <label class="form-check-label kt-checkbox">
                  <input
                    id="eShIsSpecialPM"
                    name="eShIsSpecialPM"
                    v-model="eShIsSpecialPM"
                    type="checkbox"
                    class="form-check-input"
                  />
                  เปิดใช้งาน PM (รูปแบบพิเศษ)
                  <span></span>
                </label>
              </div>
            </div>
            </div>
            
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      isChange: false,
      essaShopSubAgentId: null,
      essaShopSubAgentCode: null,
      essaShopSubAgentName: null,
      essaShopSubAgentName2: null,
      essaShopType: null,
      essaShopPMType : null,
      eShShopGroup: null,
      essaAddress: null,
      essaProvinceId: null,
      essaAmphurId: null,
      essaTumbolId: null,
      essaContactFullName: null,
      essaEmail: null,
      essaTel: null,
      essaShopCode: null,
      essaContactShopName: null,
      essaContactShopLName: null,
      essaEmpId: null,
      essaInActiveStatus: null,
      eShIsSpecialPM: false,
      essaLat: null,
      essaLng: null,
      essaMarkers: [],
      // CR-PM-2026 Req 2 — Radius config
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      apiLoadedCheckInRange: undefined, // Issue 2: defensive — track fetched value (undefined = not loaded yet)
      FileUpload: [],
      //config
      essaShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      essaShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      eShShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      essaProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      essaAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.essaProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      essaTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              ampherId: self.essaAmphurId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      essaShopCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/ShopOption",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      essaEmpIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset radius to default
    resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
    },
    checkCustomCheckInRangeMax(e) {
      const raw = e.target.value;
      const val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(() => { if (e.target) e.target.value = 10000; });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();
      input.addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const newImage = {
              pictureId: `new_${Date.now()}`,
              urlImg: e.target.result,
              fileName: file.name,
              isNew: true,
              fileDataContext: file,
              isLoaded: true,
            };
            this.FileUpload.push(newImage);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        icon: "warning",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",
      }).then((result) => {
        if (result.value) {
          this.FileUpload = this.FileUpload.filter((img) => img.pictureId !== pictureId);
          Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
        }
      });
    },
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
    async onSubmit(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      try {
        // Upload new files to GCS
        let uploadedFiles = [];
        for (let file of this.FileUpload) {
          if (file.isNew && file.fileDataContext) {
            const formData = new FormData();
            formData.append("File", file.fileDataContext);
            formData.append("IsMaster", true);
            formData.append("FolderName", "MasterShopSubAgent");

            const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });

            if (uploadResponse.data && uploadResponse.data.fileInfoId) {
              uploadedFiles.push({
                fileInfoId: uploadResponse.data.fileInfoId,
                fileName: uploadResponse.data.fileInfoId,
                downloadUrl: uploadResponse.data.fileUrl,
              });
            }
          } else if (!file.isNew) {
            // Existing image - include in the list
            uploadedFiles.push({
              fileInfoId: file.fileInfoId,
              fileName: file.fileName,
              downloadUrl: file.downloadUrl,
            });
          }
        }

        // Prepare pictures data for API
        let picturesData = uploadedFiles.map((pic) => ({
          fileInfoId: pic.fileInfoId,
          fileName: pic.fileName,
          downloadUrl: pic.downloadUrl,
        }));

        const response = await axios.put("/Api/SubAgent", {
          ShopSubAgentId: this.essaShopSubAgentId,
          SubAgentCode: this.essaShopSubAgentCode,
          ShopSubAgentName: this.essaShopSubAgentName,
          ShopSubAgentName2: this.essaShopSubAgentName2,
          ShopTypeId: this.essaShopType,
          ShopGroupId: this.eShShopGroup,
          Address: this.essaAddress,
          ProvinceId: this.essaProvinceId,
          AmphurId: this.essaAmphurId,
          TumbolId: this.essaTumbolId,
          ContactFullName: this.essaContactFullName,
          Email: this.essaEmail,
          Tel: this.essaTel,
          ShopCode: this.essaShopCode,
          Latitude: this.essaLat,
          Longitude: this.essaLng,
          ContactShopName: this.essaContactShopName,
          ContactShopLastName: this.essaContactShopLName,
          EmployeeId: this.essaEmpId,
          SubAgentPictures: picturesData,
          InActiveStatus: !this.essaInActiveStatus,
          ShopPMType: this.essaShopPMType,
          IsSpecialPM: this.eShIsSpecialPM,
          // CR-PM-2026 Req 2
          UseSettingCheckinRange: this.useSettingCheckinRange,
          CheckInRange: this.useSettingCheckinRange ? null : this.customCheckInRange,
        });

        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
            router.go(-1);
            self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      } catch (error) {
        var errorMsg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message;
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
      } finally {
        KTApp.unblockPage();
      }
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition((position) => {
        this.essaLat = position.coords.latitude;
        this.essaLng = position.coords.longitude;
        this.essaMarkers = [
          {
            position: { lat: this.essaLat, lng: this.essaLng },
            animation: google.maps.Animation.DROP,
          },
        ];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.essaLat = location.latLng.lat();
      this.essaLng = location.latLng.lng();
      map: this.map;
      this.essaMarkers = [
        { position: { lat: this.essaLat, lng: this.essaLng } },
      ];
    },
    onProvinceIdChange(id, text, data, ref) {
      let self = this;
      //console.log("onProvinceIdChange : " + self.isChange);
      if (self.isChange) {
        self.essaAmphurId = null;
        self.essaTumbolId = null;

        $("#essaAmphurId")
          .val("")
          .trigger("change");

        $("#essaTumbolId")
          .val("")
          .trigger("change");
      }
    },
    onAmphurIdChange(id, text, data, ref) {
      let self = this;
      //console.log("onAmphurIdChange : " + self.isChange);
      if (self.isChange) {
        self.essaTumbolId = null;

        $("#essaTumbolId")
          .val("")
          .trigger("change");
      }
    },
    openMap() {
      var self = this;
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          self.essaLat +
          "," +
          self.essaLng,
        "_blank"
      );
    },
  },
  computed: {},
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        essaShopSubAgentCode: "required",
        essaShopSubAgentName: "required",
        essaShopSubAgentName2: "required",
        essaShopCode: "required",
        eShShopGroup: "required",
        essaShopPMType : "required",
        // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
        customCheckInRange: {
          required: function() { return !self.useSettingCheckinRange; }
        },
      },
      messages: {
        essaShopSubAgentCode: "กรุณากรอกรหัสร้านค้า (ตัวแทนจำหน่ายย่อย)",
        essaShopSubAgentName: "กรุณากรอกชื่อร้านค้า (ตัวแทนจำหน่ายย่อย)",
        essaShopSubAgentName2: "กรุณากรอกชื่อร้านค้า 2 (ตัวแทนจำหน่ายย่อย)",
        essaShopCode: "กรุณาเลือกผู้ดูแลร้านค้าตัวแทนจำหน่ายย่อย",
        eShShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
        essaShopPMType : "ประเภทการล้างเครื่อง",
        customCheckInRange: "กรุณาระบุระยะ (เมตร)"
      },
    });

    axios
      .get("/Api/SubAgent/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.essaShopSubAgentId = response.data.subAgentId;
          self.essaShopSubAgentCode = response.data.subAgentCode;
          self.essaShopSubAgentName = response.data.subAgentName;
          self.essaShopSubAgentName2 = response.data.subAgentName2;
          self.essaAddress = response.data.address;
          self.essaEmail = response.data.email;
          self.essaTel = response.data.tel;
          self.essaContactFullName = response.data.fullName;
          self.essaInActiveStatus = !response.data.inActiveStatus;
          self.essaContactShopName = response.data.contactShopName;
          self.essaContactShopLName = response.data.contactShopLastName;
          self.eShIsSpecialPM = (response.data.isSpecialPM != null) ? response.data.isSpecialPM : false;
          // CR-PM-2026 Req 2
          self.useSettingCheckinRange = (response.data.useSettingCheckinRange != null) ? response.data.useSettingCheckinRange : true;
          self.customCheckInRange = (!self.useSettingCheckinRange) ? response.data.checkInRange : null;
          self.apiLoadedCheckInRange = (response.data.checkInRange != null) ? response.data.checkInRange : null;

          self.eessaShopPMType = response.data.shopPMType; 
            if (response.data.shopPMType) {
            self.$refs.essaShopPMTypeSelect2.setSelectedData({
              id: response.data.shopPMType,
              text: response.data.shopPMTypeName
            });
            } 

          if (response.data.shopTypeId) {
            let txt = response.data.shopTypeName;
            if (response.data.subShopTypeName)
              txt += " " + response.data.subShopTypeName;
            self.$refs.essaShopTypeSelect2.setSelectedData({
              id: response.data.shopTypeId,
              text: txt,
            });
          }

          if (response.data.shopGroupId) {
            self.$refs.eShShopGroupSelect2.setSelectedData({
              id: response.data.shopGroupId.toString(),
              text: response.data.shopGroupName
            });
          }

          if (response.data.provinceId) {
            self.$refs.essaProvinceIdSelect2.setSelectedData({
              id: response.data.provinceId,
              text: response.data.provinceName,
            });
          }

          if (response.data.ampherId) {
            self.$refs.essaAmphurIdSelect2.setSelectedData({
              id: response.data.ampherId,
              text: response.data.ampherName,
            });
          }

          if (response.data.tambolId) {
            self.$refs.essaTumbolIdSelect2.setSelectedData({
              id: response.data.tambolId,
              text: response.data.tambolName,
            });
          }

          if (response.data.shopCode) {
            self.$refs.essaShopCodeSelect2.setSelectedData({
              id: response.data.shopCode,
              text: response.data.shopName,
            });
          }

          if (response.data.employeeId) {
            self.$refs.essaEmpIdSelect2.setSelectedData({
              id: response.data.employeeId,
              text:
                "[" +
                response.data.employeeNo +
                "] " +
                response.data.employeeName +
                " " +
                response.data.employeeLastName,
            });
          }

          //Set lat lng
          response.data.latitude === null
            ? (self.essaLat = null)
            : (self.essaLat = parseFloat(response.data.latitude));
          response.data.longitude === null
            ? (self.essaLng = null)
            : (self.essaLng = parseFloat(response.data.longitude));

          self.essaMarkers = [
            { position: { lat: self.essaLat, lng: self.essaLng } },
          ];

          // Load existing pictures into FileUpload array
          if (response.data.pictures && response.data.pictures.length > 0) {
            response.data.pictures.forEach((element) => {
              self.FileUpload.push({
                pictureId: element.pictureId,
                urlImg: element.urlImg,
                fileName: element.fileName,
                fileInfoId: element.fileInfoId,
                downloadUrl: element.downloadUrl,
                isNew: false,
                isLoaded: true,
              });
            });
          }

          setTimeout(function() {
            self.isChange = true;
          }, 50);
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลคลังสินค้าคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/ShopSupAgent/EditShopSubAgent.vue